import { LinkPlugin as LexicalLinkPlugin } from '@lexical/react/LexicalLinkPlugin'
import { validateUrl } from '@src/utils/validate-url'
import * as React from 'react'

export function LinkPlugin() {
  return <LexicalLinkPlugin validateUrl={validateUrl} />
}
